import { openTelegramLink } from '@tma.js/sdk';

export function createTelegramMiniAppLink(miniAppUrl: string, startParam?: string | null): string {
    const url = new URL(miniAppUrl);
    if (startParam) url.searchParams.set('startapp', startParam);
    return url.toString();
}

export function openTelegramMiniApp(miniAppUrl?: string | null, startParam?: string | null, useBrowser = false): boolean {
    if (!miniAppUrl) return false;
    const url = createTelegramMiniAppLink(miniAppUrl, startParam);
    if (!useBrowser && openTelegramLink.isAvailable()) {
        openTelegramLink(url);
    } else {
        window.location.assign(url);
    }
    return true;
}
